import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";

export default function SupplierProducts() {
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    useScrollAnimation();

    const [products, setProducts] = useState([]);
    const [supplier, setSupplier] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch all products and logos
                const [productsRes, logosRes] = await Promise.all([
                    axios.get("https://laravel-api.alnujoud-jo.com/api/products"),
                    axios.get("https://laravel-api.alnujoud-jo.com/api/logos")
                ]);

                // Find the specific supplier
                const foundSupplier = logosRes.data.data.find(
                    logo => logo.id === parseInt(id)
                );

                // Filter products by supplier ID
                const filteredProducts = productsRes.data.data.filter(
                    product => product.logo_id === parseInt(id)
                );

                setSupplier(foundSupplier);
                setProducts(filteredProducts);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!supplier) return <div>Supplier not found</div>;

    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">
                        {t("Supplier Products")}
                    </div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">
                            {t("Supplier Products")}
                        </span>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {products.map(product => (
                            <div key={product.id} className="w-full rounded-[8px] shadow-md shadow-[#00000024]">
                                <div className="w-full h-[260px]">
                                    <img
                                        className="w-full h-full rounded-t-[8px] object-cover"
                                        src={product.image}
                                        alt={product.name_en || product.name_ar}
                                    />
                                </div>
                                <div className="p-[20px] flex flex-col gap-[25px]">
                                    <div className="flex flex-col gap-[5px]">
                                        <div className="text-[20px] text-[#017E89] font-bold">
                                            {i18n.language === 'ar' ? product.name_ar : product.name_en}
                                        </div>
                                        <p className="text-[13px]">
                                            {(i18n.language === 'ar' ? product.details_ar : product.details_en)
                                                .slice(0, 100)
                                                .concat("...")}
                                        </p>
                                    </div>
                                    <Link
                                        to={`/productsDetails/${product.id}`}
                                        className="flex items-center gap-2 text-[#017E89] font-bold"
                                    >
                                        {t("More Details")}
                                        <img
                                            className="h-auto w-4"
                                            src={require("../../assets/icons/twoLines.svg").default}
                                            alt="arrow"
                                        />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}